import { render, staticRenderFns } from "./CommonCaseStatusBadge.vue?vue&type=template&id=3e5790d5&"
import script from "./CommonCaseStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CommonCaseStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports